import React from 'react';
import { Col, ProgressBar } from 'react-bootstrap';

export default class WhiteLabelPluginUploadImage extends React.Component {
  render() {
    const { upload } = this.props;

    return (
      <Col xs={12} sm={6} md={3}>
        <div class="gallery-item">
          <img src={upload.thumbnail} class="image-responsive-height" />
          <div class="overlayer bottom-left full-width">
            <div class="overlayer-wrapper">
              <div class="gradient-grey p-l-20 p-r-20 p-t-20 p-b-5">
                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  <p class="bold text-white fs-11 p-t-10" style={{ whiteSpace: 'nowrap' }}>
                    {upload.file.name}
                  </p>
                  <ProgressBar bsStyle="info" now={upload.progress} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Col>
    );
  }
}
